/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          :  ProductsCategorySection.tsx
*
* Project Title :  Checkout
*
* Description	: Purchase Software page
*
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H175591
*
* @Date		    : Oct 1, 2019
*
* @Version      : Version 1.0
*
* 
* By            : H224423
* On            : Oct 03, 2019.
* Description   : ASDS-1478 - Dancing loader issue fix. Renamed inlineClassName to inlineclassname to avoid mismatch with DOM tags.
******************************************************************************/
import React from 'react';
import { InLineLoader } from '../../Loader/Loader';
import { Grid } from '@scuf/common';

function ProductCategoryLoader() {
    return (
        <Grid.Row>
            <Grid.Column>
                <InLineLoader text="Fetching Categories" className="category-loader" inlineclassname="product-categories" loading={true} overlayColor='rgb(247, 247, 247)'>
                </InLineLoader>
            </Grid.Column>
        </Grid.Row>
    );
}

export default ProductCategoryLoader;